import { Navigate, Outlet } from "react-router-dom";


function PublicRoute({ component: Component, ...rest }: any) {

    return (localStorage.getItem("isLogged") === "false" || !localStorage.getItem("isLogged")) ? <Outlet /> : <Navigate to="/home" />;

}

export default PublicRoute 